import React, { useState, useRef, useEffect, Suspense } from "react";
import { useTranslation } from "react-i18next";
import "../../i18n";

// ✅ Lazy load wrappers (Code Splitting)
const NoCopyWrapper = React.lazy(() => import("../../utils/NoCopyWrapper"));
const NoZoomWrapper = React.lazy(() => import("../../utils/NoZoomWrapper"));

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(
    localStorage.getItem("language") || "en"
  );
  const [isDesktopOpen, setIsDesktopOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const desktopRef = useRef(null);

  const languages = [
    { label: "English", code: "en" },
    { label: "Gujarati", code: "gu" },
    { label: "Hindi", code: "hi" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (desktopRef.current && !desktopRef.current.contains(event.target)) {
        setIsDesktopOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLanguageChange = (lang) => {
    setSelectedLang(lang.code);
    i18n.changeLanguage(lang.code);
    localStorage.setItem("language", lang.code);
    setIsDesktopOpen(false);
    setIsMobileOpen(false);
  };

  const closeMobileModal = () => {
    setIsMobileOpen(false);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NoZoomWrapper>
        <NoCopyWrapper>
          {/* ✅ Desktop Dropdown */}
          <div className="desktop-only">
            <div
              className="language-selector"
              ref={desktopRef}
              onClick={() => setIsDesktopOpen(!isDesktopOpen)}
            >
              <div className="selected-lang">
                {languages.find((l) => l.code === selectedLang)?.label}
                <span className={`arrow ${isDesktopOpen ? "rotate" : ""}`}>
                  <i className="fa-solid fa-angle-down"></i>
                </span>
              </div>
              {isDesktopOpen && (
                <div className="lang-options">
                  {languages.map((lang) => (
                    <div
                      key={lang.code}
                      className={`lang-option ${
                        lang.code === selectedLang ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLanguageChange(lang);
                      }}
                    >
                      {lang.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* ✅ Mobile Modal */}
          <div className="mobile-only">
            <div
              className="language-selector-mobile"
              onClick={() => setIsMobileOpen(true)}
            >
              <div className="selected-lang">
                {languages.find((l) => l.code === selectedLang)?.label}
                <span className="arrowes">
                  <i className="fa-solid fa-angle-down"></i>
                </span>
              </div>
            </div>

            {/* Mobile Modal Overlay */}
            {isMobileOpen && (
              <div
                className="language-modal-overlay-mobile"
                onClick={closeMobileModal}
              >
                <div
                  className="language-modal-mobile"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-header-mobile">
                    <h3>Languages</h3>
                    <button
                      className="close-btn-mobile"
                      onClick={closeMobileModal}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="modal-options">
                    {languages.map((lang) => (
                      <div
                        key={lang.code}
                        className={`modal-option ${
                          lang.code === selectedLang ? "active" : ""
                        }`}
                        onClick={() => handleLanguageChange(lang)}
                      >
                        {lang.label}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </NoCopyWrapper>
      </NoZoomWrapper>
    </Suspense>
  );
};

export default LanguageSelector;
